/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_Preview_CaptionInputs */

const en_gc_home_preview_caption = /** @type {(inputs: Gc_Home_Preview_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The actual GridCraft workspace, built by ArtCraft.`)
};

const zh_gc_home_preview_caption = /** @type {(inputs: Gc_Home_Preview_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ArtCraft 开发的真实 GridCraft 工作区。`)
};

/**
* | output |
* | --- |
* | "The actual GridCraft workspace, built by ArtCraft." |
*
* @param {Gc_Home_Preview_CaptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_preview_caption = /** @type {((inputs?: Gc_Home_Preview_CaptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_Preview_CaptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_preview_caption(inputs)
	return zh_gc_home_preview_caption(inputs)
});
export { gc_home_preview_caption as "gc.home.preview_caption" }